let locale = globalLocale !== undefined ? globalLocale : (navigator.language || navigator.userLanguage).substr(0, 2);
/* previously we used globals.. but by using globalThis, your code will work in window and non-window contexts */
const { whiteLabelSettings } = globalThis;

if (typeof whiteLabelSettings !== 'undefined') {
  if (whiteLabelSettings.languages && whiteLabelSettings.languages.length) {
    if (whiteLabelSettings.languages.indexOf(locale) === -1) {
      locale = whiteLabelSettings.languages[0];
    }
  }
}
globalThis.globalLocale = locale;

export default {
  // eslint-disable-next-line no-undef
  debug: DEBUG,

  locale,
  whiteLabelSettings,
};
